import ConsentProvider from "./ConsentProvider";
class DummyConsentProvider extends ConsentProvider {
    constructor(onChangeCallback) {
        super();
        this.getAllowTracking = this.getAllowTracking.bind(this);
    }
    getAllowTracking() {
        return true;
    }
    handleConsentPush() {
        return true;
    }
}
export default DummyConsentProvider;
